import { useIntl, FormatDateOptions } from 'react-intl'

const isValidDateString = (dateString: string): boolean => {
  return !Number.isNaN(Date.parse(dateString))
}

const useFormatPromotionPeriod = (startDate: string, endDate: string): string => {
  const dateFormatOptions: FormatDateOptions = { month: 'short', day: 'numeric' }
  const { formatDate, formatTime } = useIntl()

  if (!isValidDateString(startDate) || !isValidDateString(endDate)) return ''

  const formatDateWithOptionalTime = (dateString: string) => {
    if (dateString.includes('T')) {
      return `${formatDate(dateString, dateFormatOptions)} ${formatTime(dateString)}`
    }

    return formatDate(dateString, dateFormatOptions)
  }

  return `${formatDateWithOptionalTime(startDate)} - ${formatDateWithOptionalTime(endDate)}`
}

export default useFormatPromotionPeriod
